import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useLanguage } from '../../contexts/LanguageContext';
import { usePageAccess } from '../../hooks/usePageAccess';
import {
  Home,
  Package,
  TruckIcon,
  Truck,
  BarChart3,
  ClipboardList,
  Users,
  Store,
  QrCode
} from 'lucide-react';

interface BottomMenuItem {
  path: string;
  icon: React.FC<{ className?: string }>;
  label: string;
  pageKey?: string;
}

export const BottomNavigation: React.FC = () => {
  const { user } = useAuth();
  const { t } = useLanguage();
  const location = useLocation();
  const { hasAccess } = usePageAccess();

  let menuItems: BottomMenuItem[] = [];

  if (user?.role === 'super_admin') {
    menuItems = [
      { path: '/admin', icon: Users, label: t('nav.admin') }
    ];
  } else {
    const allItems: BottomMenuItem[] = [
      { path: '/dashboard',        icon: Home,           label: t('nav.dashboard') },
      { path: '/inventory',        icon: Package,        label: t('nav.inventory'),  pageKey: 'inventory' },
      { path: '/incoming',         icon: TruckIcon,      label: 'In',               pageKey: 'incoming' },
      { path: '/outgoing',         icon: Truck,          label: 'Out',              pageKey: 'outgoing' },
      { path: '/in-house-shipment', icon: Store,         label: 'IHS',              pageKey: 'in-house-shipment' },
      { path: '/worker-terminal',  icon: ClipboardList,  label: 'Terminal',         pageKey: 'worker-terminal' },
    ];

    menuItems = allItems.filter((item) => {
      if (!item.pageKey) return true;
      return hasAccess(item.pageKey);
    });
  }

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 lg:hidden z-50 safe-bottom">
      <div className="flex items-center justify-around h-16 px-2">
        {menuItems.map((item) => {
          const Icon = item.icon;
          const isActive = location.pathname === item.path;

          return (
            <Link
              key={item.path}
              to={item.path}
              className={`
                flex flex-col items-center justify-center flex-1 h-full space-y-1 transition-colors duration-200
                ${isActive
                  ? 'text-primary-600 dark:text-primary-400'
                  : 'text-gray-500 dark:text-gray-400'
                }
              `}
            >
              <Icon className={`h-6 w-6 ${isActive ? 'scale-110' : ''} transition-transform`} />
              <span className="text-xs font-medium truncate max-w-full px-1">
                {item.label}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};
